import { render, staticRenderFns } from "./MyPrize.vue?vue&type=template&id=78e75627&scoped=true&"
import script from "./MyPrize.vue?vue&type=script&lang=ts&"
export * from "./MyPrize.vue?vue&type=script&lang=ts&"
import style0 from "./MyPrize.vue?vue&type=style&index=0&id=78e75627&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78e75627",
  null
  
)

export default component.exports